import { render } from "./WalletBanner.vue?vue&type=template&id=504cd944"
import script from "./WalletBanner.vue?vue&type=script&lang=js"
export * from "./WalletBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__